import type { t_remote_type, IRunPlan } from '../types';

import type { RemoteView } from '../remote_views/remote_view';
import { HostingRemoteView } from '../remote_views/hosting';
import { MicroRemoteView } from '../remote_views/micro';
import { CrateRemoteView } from '../remote_views/crate';

/**
 * build a remote view based on the `remote_View.type`
 */
export class RemoteViewFactory {
  /**
   * hold all remote view writers
   */
  readonly remoteViews: Record<t_remote_type, (runPlan: IRunPlan) => RemoteView> = {
    hosting: (runPlan) => new HostingRemoteView(runPlan),
    crate: (runPlan) => new CrateRemoteView(runPlan),
    micro: (runPlan) => new MicroRemoteView(runPlan)
  };

  /**
   * create a remote view facade
   *
   * @param frameOptions
   * @returns
   */
  async create(runPlan: IRunPlan): Promise<RemoteView> {
    const remoteViewType = runPlan.remote_view.type;
    // TODO: what if type is incorrect
    //
    const createRemoteView = this.remoteViews[remoteViewType];
    if (!createRemoteView) {
      throw `${remoteViewType} is not a supported type of remote view`;
    }

    return createRemoteView(runPlan);
  }
}
